import BaseGenericRequest from "../BaseGenericRequest";
import TaskResponse from "../TaskResponse";
import {METHOD} from "@cuatroochenta/co-generic-request";
import Urls from "../Urls";
import {generateRoute} from "../../utils/Router";
import VehicleModel from "../../model/VehicleModel";

export default class TaskVehicleModelDetail extends BaseGenericRequest<{}, TaskResponse<VehicleModel>> {

    public constructor(vehicleModelId: string) {
        super(METHOD.GET, generateRoute(Urls.URL_VEHICLE_MODEL_DETAIL, {uuid: vehicleModelId}));
    }
}
